import store from "../../../store";
import { EVENT_SERIES_UPDATE_BULK, EVENT_SERIES_UPDATE_SINGLE } from "../../../store/slices";
import { DatabaseInstance } from "../../../utils/databaseClass";

// TODO: Create sharable types between backend and frontend.
// TODO: Build a thunk wrapper that can be used to call the API and dispatch the action.
class EventSeriesClass {
  private getHeaders = () => {
    const business = store.getState().business;

    if (!business.activeBusiness) return {};

    const {
      activeBusiness: { id },
      businessType,
    } = business;

    return {
      actingasid: id,
      actingastype: businessType,
    };
  };

  public get = async (id: string) => {
    const res = await DatabaseInstance.getRecord({
      endpoint: `event-series/${id}`,
    });

    store.dispatch(EVENT_SERIES_UPDATE_SINGLE(res));
  };

  public listForCurrentBusiness = async () => {
    const res = await DatabaseInstance.getRecord({
      endpoint: `event-series`,
      headers: this.getHeaders(),
    });

    store.dispatch(EVENT_SERIES_UPDATE_BULK(res));
  };

  public create = async (data: any) => {
    const res = await DatabaseInstance.createRecord({
      endpoint: `event-series`,
      data,
      headers: this.getHeaders(),
    });

    store.dispatch(EVENT_SERIES_UPDATE_SINGLE(res));
  };

  public update = async (id: number, data: any) => {
    const res = await DatabaseInstance.createRecord({
      endpoint: `event-series/${id}`,
      headers: this.getHeaders(),
      data,
    });

    store.dispatch(EVENT_SERIES_UPDATE_SINGLE(res));
  };

  public getLatestExperience = async (id: number) => {
    return DatabaseInstance.getRecord({
      endpoint: `event-series/${id}/latest`,
      isPublic: true,
    });
  };
}

export const EventSeriesInstance = new EventSeriesClass();
